import React from 'react';
import * as Formatting from 'fw/misc/Formatting'

class CurrencyWithoutDecimals extends React.Component {
	shouldComponentUpdate(nextProps) {
		return (
			nextProps.value !== this.props.value);
	}

    render() {
        return <div style={{textAlign:'right'}}>{Formatting.formatCurrency(this.props.value, 0)}</div>
    }
}

export default CurrencyWithoutDecimals;


// WEBPACK FOOTER //
// ./src/fw/components/formatter/CurrencyWithoutDecimals.js